export const PATH = {
    BRIEF: 'brief',
    PIRAMIDE: 'piramide'
  }